// @react-functional

import React from 'react';
import { ModalContext, ModalType } from './ModalContext';

export type WithModalProps = {
  openModal: (component: ModalType<Object | undefined>) => void;
};

type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
type Subtract<T extends K, K> = Omit<T, keyof K>;

export function withModal<
  P extends React.ComponentType<React.ComponentProps<P> & WithModalProps>,
  ResolvedProps = JSX.LibraryManagedAttributes<
    P,
    Subtract<React.ComponentProps<P>, WithModalProps>
  >
>(WrappedComponent: P) {
  const ComponentWithModal: React.FC<ResolvedProps> = (props) => (
    <ModalContext.Consumer>
      {({ openModal }) => (
        <WrappedComponent
          {...(props as JSX.LibraryManagedAttributes<
            P,
            React.ComponentProps<P>
          >)}
          openModal={openModal}
        />
      )}
    </ModalContext.Consumer>
  );
  return ComponentWithModal;
}
